import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import type { Screen } from '@/types'

export const useUIStore = defineStore('ui', () => {
  const currentScreen: Ref<Screen> = ref('home')
  const showJoinModal: Ref<boolean> = ref(false)
  const showOptionsModal: Ref<boolean> = ref(false)
  const showRoomSettingsModal: Ref<boolean> = ref(false)
  const showQRModal: Ref<boolean> = ref(false)
  const currentQRCode: Ref<string> = ref('')

  const navigateTo = (screen: Screen): void => {
    currentScreen.value = screen
  }

  const openJoinModal = (): void => {
    showJoinModal.value = true
  }

  const closeJoinModal = (): void => {
    showJoinModal.value = false
  }

  const openOptionsModal = (): void => {
    showOptionsModal.value = true
  }

  const closeOptionsModal = (): void => {
    showOptionsModal.value = false
  }

  const openRoomSettingsModal = (): void => {
    showRoomSettingsModal.value = true
  }

  const closeRoomSettingsModal = (): void => {
    showRoomSettingsModal.value = false
  }

  const openQRModal = (code: string): void => {
    currentQRCode.value = code
    showQRModal.value = true
  }

  const closeQRModal = (): void => {
    showQRModal.value = false
    currentQRCode.value = ''
  }

  return {
    currentScreen,
    showJoinModal,
    showOptionsModal,
    showRoomSettingsModal,
    showQRModal,
    currentQRCode,
    navigateTo,
    openJoinModal,
    closeJoinModal,
    openOptionsModal,
    closeOptionsModal,
    openRoomSettingsModal,
    closeRoomSettingsModal,
    openQRModal,
    closeQRModal
  }
})
